import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Actions from "../../redux/action";
import Placeholder from "../../asset/images/img.jpg";
import cloneDeep from "lodash.clonedeep";
import { toast } from "react-toastify";
import ModalPopup from "../../component/ModalPopup";
import { getRandomNumber } from "../../Utility/Utils";
export class AddOn extends React.Component {
  constructor(props) {
    super(props);
    const cartProductInfo = props?.getPimCartDetails?.pimCart?.products
      ?.reverse()
      .find(
        (cartDetailsProductList) =>
          cartDetailsProductList.sku === props.productInfo.sku
      );
    const cartInfo = cartProductInfo?.selectedAddOns;
    const subInfo = cartProductInfo?.substitutionListDto;
    const getSelctedAddons = cartInfo?.reduce((previous, current) => {
      previous.push(current.upc);
      return previous;
    }, []);
    const getSelctedSub = subInfo?.reduce((previous, current) => {
      previous.push({ baseIngredientSku: current?.baseIngredientSku, substituteIngredientSku: current?.substituteIngredientSku });
      return previous;
    }, []);
    this.state = {
      checkedItemsIds: getSelctedAddons || [],
      checkedIds: getSelctedSub || [],
      isUpdateProduct: !!cartInfo,
      bistroNotes: ""
    };
  }

  onChangeCheckbox(details) {
    const { productInfo } = this.props;
    const { addOnList } = productInfo;
    const { checkedItemsIds } = this.state;
    const index = checkedItemsIds?.findIndex((s) => s === details?.upc);
    const freeAddonList = addOnList?.filter((obj) => obj?.sellingPrice === 0)
    const freeAddonListIndex = freeAddonList?.map((o) => { return checkedItemsIds?.findIndex((obj) => obj === o?.upc) });
    const removeIndex = freeAddonListIndex?.filter((v) => v >= 0)
    if (index === -1) {
      if (details?.sellingPrice !== 0) {
        // checkedItemsIds.splice(newD, 1);
        this.setState({ checkedItemsIds: [...checkedItemsIds, details?.upc] });
      } else {
        if (removeIndex.length > 0) {
          checkedItemsIds.splice(removeIndex, 1);
        }
        this.setState({ checkedItemsIds: [...checkedItemsIds, details?.upc] });
      }
    } else {
      const items = [...checkedItemsIds];
      items.splice(index, 1);
      this.setState({ checkedItemsIds: items });
    }
  }
  onChangeCheck(details) {
    const { checkedIds } = this.state;
    const { excludeList } = this.props?.productInfo;
    const index = checkedIds?.findIndex((o) => {
      if (o?.baseIngredientSku === details?.baseIngredientSku && o?.substituteIngredientSku === details?.substituteIngredientSku) {
        return o
      }
    });
    let arr = []
    const data = excludeList.forEach((o) => arr.push(...o?.substitutions))
    const newData = arr?.filter((o) => o?.baseIngredientSku === details?.baseIngredientSku)
    if (index !== -1) {
      const items = [...checkedIds];
      items.splice(index, 1);
      this.setState({ checkedIds: items });
    } else {
      const newSku = newData?.map((o) => o?.substituteIngredientSku)
      const array1 = newData?.filter(val => checkedIds.find((o) => o?.baseIngredientSku === val?.baseIngredientSku && o?.substituteIngredientSku === val?.substituteIngredientSku));
      const newindex = checkedIds?.findIndex((checkedId) => checkedId?.substituteIngredientSku === array1[0]?.substituteIngredientSku && checkedId?.baseIngredientSku === array1[0]?.baseIngredientSku)
      if (newindex == -1) {
        return this.setState({ checkedIds: [...checkedIds, { substituteIngredientSku: details?.substituteIngredientSku, baseIngredientSku: details?.baseIngredientSku }] })
      } else {
        const items = [...checkedIds];
        items.splice(newindex, 1);
        return this.setState({ checkedIds: [...items, { substituteIngredientSku: details?.substituteIngredientSku, baseIngredientSku: details?.baseIngredientSku }] })
      }
    }
    // const index = checkedIds?.findIndex((s) => s === details?.substituteIngredientSku);
    // if (index === -1) {
    //   // checkedIds.splice(index, 1);
    //   this.setState({ checkedIds: [...checkedIds, details?.substituteIngredientSku] });
    // } else {
    //   const items = [...checkedIds];
    //   items.splice(index, 1);
    //   this.setState({ checkedIds: items });
    // }

  }

  addOrUpdate() {
    let sameAddon = false;
    let sameSubtitution = false;
    let sameBistroNotes = false;
    const { productInfo } = this.props;
    const { checkedItemsIds, checkedIds } = this.state;
    const filteredData = checkedIds?.map((o) => o?.substituteIngredientSku)
    const {
      pimCart: { products },
    } = this.props.getPimCartDetails;
    const allProductsPerId = products?.filter(
      (data) => data.sku === productInfo.sku
    );
    const currentProduct = products?.find(o => productInfo?.productId === o?.productId)
    const cartElement = allProductsPerId?.find((cartProduct) => {
      const addonupcs = cartProduct?.selectedAddOns?.map((ml) => ml.upc);
      const substitutionArray = cartProduct?.substitutionListDto
      if (addonupcs.length === checkedItemsIds.length && substitutionArray.length === checkedIds.length) {
        sameAddon = addonupcs.every((element, index) => {
          let sameAddonIndex = checkedItemsIds?.indexOf(element)
          if (sameAddonIndex !== null && sameAddonIndex !== undefined && sameAddonIndex > -1) {
            return true;
          }
          return false;
        });
        sameSubtitution = substitutionArray.every((element, index) => {
          if (element.baseIngredientSku === checkedIds[index].baseIngredientSku && element.substituteIngredientSku === checkedIds[index].substituteIngredientSku) {
            return true;
          }
          return false;
        });
      }
      if (sameAddon && sameSubtitution && (currentProduct?.customerInstruction === this.state.bistroNotes)) {
        return cartProduct
      }

    });
    if (cartElement) {
      this.updateItemToCart(cartElement);
    } else {
      this.addAddonsToCartItem();
    }
  }

  pimCartCallback = (response) => {
    const { closeAddOnModal } = this.props
    const { response_code } = response;
    if (response_code === 0) {
      closeAddOnModal();
    } else {
      toast.error(response?.response_message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };


  addAddonsToCartItem() {
    let excludeAndIncludeItems = []
    const { productInfo } = this.props;
    const { checkedIds, checkedItemsIds } = this.state;
    const productExcludeList = productInfo?.excludeList?.map(item => {
      checkedIds.map((obj) => {
        item.substitutions.map(subListobj => {
          if (obj?.baseIngredientSku === subListobj?.baseIngredientSku && obj?.substituteIngredientSku === subListobj?.substituteIngredientSku) {
            excludeAndIncludeItems.push({
              substituteIngredientSku: subListobj?.substituteIngredientSku,
              baseIngredientSku: subListobj?.baseIngredientSku,
            });
          }
        })

      });
    })
    const params = {
      bistroProduct: true,
      productSku: productInfo?.sku,
      storeId: 1,
      quantity: 1,
      addOnIds: checkedItemsIds ? checkedItemsIds : [],
      excludeAndIncludeItems: excludeAndIncludeItems ? excludeAndIncludeItems : [],
      customerInstruction: this.state.bistroNotes
    };

    this.props.createPimCart(params, this.pimCartCallback);
  }

  updateItemToCart(cartElement) {
    let params = {
      bistroProduct: true,
      cartItemId: cartElement?.cartItemId,
      storeId: 1,
      quantity: cartElement?.quantity + 1,
      addOnIds: [],
      excludeAndIncludeItems: [],
      customerInstruction: this.state.bistroNotes
    };
    this.props.updatePimCart(params, this.pimCartCallback);
  }

  _totalAmount() {
    const { checkedItemsIds, checkedIds } = this.state;
    const { productInfo } = this.props;
    const { addOnList, sellingPrice, excludeList = [] } = productInfo;
    const totalExculed = checkedIds.map((obj) => {
      return excludeList?.reduce((prev, curr) => {
        const newcurrentObj = curr?.substitutions.find((f) => obj?.baseIngredientSku === f?.baseIngredientSku && obj?.substituteIngredientSku === f?.substituteIngredientSku)
        if (!newcurrentObj?.price) return prev + 0;
        else return prev + newcurrentObj?.price;
      }, 0)
    })
    const totalExculedCost = totalExculed.reduce((a, b) => a + b, 0)
    // const coun = checkedIds.reduce((prev, curr) => {
    //   const data = excludeList?.map((obj) => {
    //     newcurrentObj = obj?.substitutions.find((f) => f.substituteIngredientSku === curr)
    //   })
    //   return prev + newcurrentObj?.price ?? 0 

    // }, 0);
    const count = checkedItemsIds.reduce((prev, curr) => {
      const currentObj = addOnList?.find((f) => f.upc === curr);
      if (currentObj?.sellingPrice === 0) return prev;
      else return prev + currentObj?.sellingPrice;
    }, 0);
    const totalCost = count + sellingPrice + Number(totalExculedCost ?? 0)
    return totalCost?.toFixed(2);
  }
  render() {
    const { closeAddOnModal, productInfo } = this.props;
    const { addOnList, excludeList = [], hasAddOns, hasExcludes } = cloneDeep(
      productInfo || {}
    );
    const { checkedItemsIds, checkedIds } = this.state;
    const productAddOnMappingList = [
      {
        info: "Choice of dressing (choose one)",
        data: [...addOnList?.filter((i) => i.sellingPrice === 0)],
      },
      {
        info: "Add-ons",
        data: [...addOnList?.filter((i) => i.sellingPrice > 0)],
      },
    ];
    const productExcludeListMapping = [
      {
        info: "Substitution List (choose one with each substitution)",
        data: [...excludeList],
      },
    ];

    return (
      <ModalPopup isAddon={true} onCloseModal={closeAddOnModal}>
        <div className="row align-items-center mb-4 pb-3 border-bottom">
          <div className="col-auto">
            <img
              alt="images"
              height="60px"
              src={
                productInfo.imageUrl
                  ? productInfo.imageUrl + '?$' + getRandomNumber()
                  : Placeholder
              }
            />
          </div>
          <div className="col font16 fw-bold">
            Customize {productInfo?.productName}
          </div>
        </div>
        <>
          <div className="ScrollStyle">
            <div style={{ width: '80%' }}>
              {productAddOnMappingList.map((pAddons) => {
                return (
                  <form>
                    {pAddons?.info && pAddons?.data?.length ? (
                      <div className="row mt-4 mb-3">
                        <div className="col fw-bold">
                          {pAddons?.info}
                        </div></div>
                    ) : null}

                    {pAddons?.data?.map((addons) => {
                      const price =
                        addons?.sellingPrice !== 0
                          ? `$${addons?.sellingPrice?.toFixed(2)}`
                          : "Free";
                      return (
                        <>
                          <div className="row mb-2">
                            <div className="col-auto">
                              <div className="form-check" style={{ cursor: 'pointer' }}>
                                <input
                                  className="form-check-input"
                                  type={price === "Free" ? "radio" : "checkbox"}
                                  id={`checkboxNoLabel_${addons?.upc}`}
                                  aria-label="..."
                                  defaultChecked={checkedItemsIds.includes(
                                    addons?.upc
                                  )}
                                  onClick={() =>
                                    addons && this.onChangeCheckbox(addons)
                                  }
                                  checked={checkedItemsIds.includes(addons?.upc)}

                                />
                                <label style={{ cursor: 'pointer' }} className="form-check-label" for={`checkboxNoLabel_${addons?.upc}`}>
                                  {addons?.productName}
                                </label>
                              </div>
                            </div>
                            <div className="col text-end"> {`${price}`}</div>
                          </div>
                        </>
                      );
                    })}
                    {pAddons?.data.length > 0 && <hr></hr>}
                  </form>
                );
              })}
              {productExcludeListMapping.map((pExclue) => {
                const substitutionsData = pExclue?.data.map((o) => o?.substitutions).flat().length
                return (
                  <form>
                    {substitutionsData > 0 && pExclue?.data?.length ? (
                      <div className="row mt-4 mb-3">
                        <div className="badge product-tag" style={{ textAlign: "left", width: "auto", fontWeight: "bolder" }}>
                          {pExclue?.info}
                        </div>
                      </div>
                    ) : null}

                    {pExclue?.data?.map((substitutionsList) => {
                      return (
                        <>
                          {substitutionsList?.substitutions.length > 0 && <div className="row mt-2 mb-3">
                            <div className="col">Replace <b>"{substitutionsList?.productDisplayName.toUpperCase()}"</b> With
                            </div>
                          </div>}

                          {substitutionsList?.substitutions.map((obj) => {
                            return (
                              <div className="row mb-2">
                                <div className="col-auto">
                                  <div className="form-check" style={{ cursor: 'pointer' }}>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id={`checkboxNo_${obj?.substituteIngredientSku}${obj?.baseIngredientSku}`}
                                      aria-label="..."
                                      defaultChecked={checkedIds?.filter((o) => {
                                        if (o?.baseIngredientSku === obj?.baseIngredientSku && o?.substituteIngredientSku === obj?.substituteIngredientSku) {
                                          return o
                                        }
                                      }).length > 0}
                                      onClick={() =>
                                        obj && this.onChangeCheck(obj)
                                      }
                                      checked={
                                        checkedIds.filter((o) => {
                                          if (o?.baseIngredientSku === obj?.baseIngredientSku && o?.substituteIngredientSku === obj?.substituteIngredientSku) {
                                            return o
                                          }
                                        }).length > 0
                                      }

                                    />
                                    <label style={{ cursor: 'pointer' }} className="form-check-label" for={`checkboxNo_${obj?.substituteIngredientSku}${obj?.baseIngredientSku}`}>
                                      {obj?.substituteIngredientDisplayName}
                                    </label>
                                  </div>
                                </div>
                                <div className="col text-end"> {`$${obj?.price?.toFixed(2)}`}</div>
                              </div>
                            )
                          })

                          }
                          {substitutionsList?.substitutions.length > 0 && <hr></hr>}
                        </>
                      );
                    })}

                  </form>
                );
              })}
              {
                <div class="form-floating mb-3">
                  <input type="text" maxLength={200} className="form-control form_custom" onChange={(e) => this.setState({ bistroNotes: e.target.value })} id="floatingInput" placeholder="Enter bistro notes here" />
                  <label for="floatingInput">Customer Instructions</label>
                </div>
              }
            </div>
          </div>
        </>
        <div className="text-center pt-5 mb-3">
          <button
            type="button"
            className="btn btn-dark big-btn w-100 px-5 text-uppercase"
            onClick={() => this.addOrUpdate()}
          >
            Add Items <strong>${this._totalAmount()}</strong>
          </button>
        </div>
      </ModalPopup>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    getFoodProductList: Actions.getFoodProductList(state),
    getPimCartDetails: Actions.getPimCartDetails(state),
  };
};
export default withRouter(
  connect(mapStateToProps, {
    createPimCart: Actions.createPimCart,
    updatePimCart: Actions.updatePimCart,
    saveBistroNotes: Actions.bistroNotesSuccess,
  })(AddOn)
);
